
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface LimitReachedModalProps {
  isOpen: boolean;
  onClose: () => void;
  toolName?: string;
}

export function LimitReachedModal({ isOpen, onClose, toolName = "cet outil" }: LimitReachedModalProps) {
  const navigate = useNavigate();
  
  const handleSignUp = () => {
    navigate("/auth?tab=signup");
    onClose();
  };
  
  const handleSignIn = () => {
    navigate("/auth?tab=signin");
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-bold mb-2">
            Limite d'utilisations atteinte
          </DialogTitle>
          <DialogDescription className="text-center">
            Vous avez atteint la limite d'utilisations gratuites pour {toolName}. 
            Pour continuer à utiliser nos outils gratuitement, créez un compte ou connectez-vous.
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex flex-col gap-4 mt-4">
          <Button onClick={handleSignUp} className="w-full">
            Créer un compte gratuitement
          </Button>
          <Button onClick={handleSignIn} variant="outline" className="w-full">
            Se connecter
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
